var React = require('react');

function MobileMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z","vectorEffect":"non-scaling-stroke"})));
}

MobileMenu.defaultProps = {"version":"1.2","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 24 24","width":"31","height":"31"};

module.exports = MobileMenu;

MobileMenu.default = MobileMenu;
